// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__3rEmH","ranges":"BmiRanges_ranges__3o-9t"};